// LICENSE_CODE ZON
 /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_user_circle from '../../../../hola/pub/img/hola2023/icons/24/user_circle.svg';
import Icon_cart from '../../../../hola/pub/img/hola2023/icons/24/cart.svg';
import Icon_chevron_right from '../../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {use_login} from './use_login';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import styles from './nav_user.module.less';

interface i_user_links_props {
    cp_after_login?: boolean;
    cp_link?: string;
    no_getstarted?: boolean;
    cp_always_icon?: boolean;
}
const User_links = (props: i_user_links_props)=>{
    const {no_getstarted} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const [shift, set_shift] = useState<number>(0);
    const {T} = use_translation_v({no_defaults: true});
    const {state} = useLocation();
    const start_ref = useRef<HTMLDivElement>();
    const {on_login, show_login_form} = use_login(
        props.cp_after_login, props.cp_link);
    useEffect(()=>{
        const cur = start_ref.current;
        if (cur)
            setTimeout(()=>set_shift(cur.offsetWidth));
    }, [start_ref.current]);
    useEffect(()=>{
        if ((state as object_of<boolean>)?.need_login)
            show_login_form();
    }, [state]);
    return <div className={cn(styles.user_links)}>
      {/* <Lang_picker/> */}
      <a style={{'--shift': `${shift}px`} as CSSProperties}
        className={cn(theme.u4, styles.login,
          props.cp_always_icon && styles.icon_login)} onClick={on_login}
        data-clickid="nav_login">{props.cp_always_icon ? <Icon_user_circle/>
        : <T>Log in</T>}</a>
      {!no_getstarted && <div ref={start_ref} className={styles.start}>
        <Button color="black" size="xs" caption={<T>Get started</T>}
          to="/dashboard" clickid="nav_start" round={false}/>
      </div>}
    </div>;
};

interface i_nav_user_props {
    has_user?: boolean;
    is_scrolled?: boolean;
    cp_after_login?: boolean;
    cp_always_icon?: boolean;
    cp_link?: string;
    with_cart?: boolean;
    no_getstarted?: boolean;
}
export const Nav_user = (props: i_nav_user_props)=>{
    const {has_user, is_scrolled, cp_link, cp_after_login,
      with_cart, no_getstarted, cp_always_icon} = props;
    const cls = cn(styles.nav_user, styles.toolip_nav_user,
        is_scrolled && styles.scrolled);
    const {T} = use_translation_v({no_defaults: true});
    const {set_qs} = use_qs_with_set();
    return <div className={cls}>
      {/* {has_user && <Lang_picker/>} */}
      {has_user ? <Button color="transparent_black" size="sm"
        caption={<T>Dashboard</T>} to={cp_link} clickid="nav_dashboard"
        round={false} cls={styles.dashboard} icon_right={<Icon_chevron_right/>}
      /> : <User_links cp_link={cp_link} cp_after_login={cp_after_login}
        cp_always_icon={cp_always_icon} no_getstarted={no_getstarted}
      />}
      {with_cart && <div className={styles.cart_icon}>
        <Icon_cart onClick={()=>{
          set_qs({with_cart: 'true'});
        }}/>
      </div>}
    </div>;
};
